import { render, staticRenderFns } from "./edoCta.vue?vue&type=template&id=2926abf5"
import script from "./edoCta.vue?vue&type=script&lang=js"
export * from "./edoCta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports